import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import Login from "../features/login/LoginView";
import PassChange from "../features/passChange/PassChangeView";
import Register from "../features/register/RegisterView";
import OnRent from "../features/onRent/OnRentView";
import RentLog from "../features/rentLog/RentLogView";
import Subscriber from "../features/subscriber/SubscriberView";
import PortInfo from "../features/portInfo/PortInfoView";
import ReceiptAdmin from "../features/receiptAdmin/ReceiptAdminView";
import Layout from "./Layout";
import UserInfo from "../features/userInfo/UserInfoView";
import Coupon from "../features/coupon/CouponView";
import CouponCreate from "../features/coupon/CouponCreateView";
import Inquiry from "../features/inquiry/InquiryView";
import SegwayInfo from "../features/segwayInfo/SegwayInfoView";
import PortChange from "../features/segwayInfo/PortChangeView";
import UserDetail from "../features/userDetail/UserDetailView";
import Port1 from "../features/port1/Port1View";
import Port2 from "../features/port2/Port2View";
import Port3 from "../features/port3/Port3View";
import Pay from "../features/pay/PayView";
import Rental from "../features/rental/RentalView";
import Map from "../features/map/MapView";
import RideAdjustment from "../features/rideAdjustment/RideAdjustmentView";
import PortCreate from "../features/portInfo/PortCreateView";

const App: React.FC = () => {
  return (
    <Router>
      <Switch>
        {/* サイドメニュー必要ないコンポーネント*/}
        <Route path="/Login" component={Login} />
        <Route path="/PassChange" component={PassChange} />
        <Route path="/Register" component={Register} />
        {/* サイドメニューが必要なコンポーネント */}
        <Route>
          <Layout>
            <Switch>
              <PrivateRoute path="/map" component={Map} />
              <PrivateRoute path="/User_detail" component={UserDetail} />
              <PrivateRoute path="/Port_create" component={PortCreate} />
              <PrivateRoute path="/Ride_adjustment" component={RideAdjustment} />
              <PrivateRoute path="/Port_change" component={PortChange} />
              <PrivateRoute path="/Segway_info" component={SegwayInfo} />
              <PrivateRoute path="/Coupon_create" component={CouponCreate} />
              <PrivateRoute path="/Coupon" component={Coupon} />
              <PrivateRoute path="/Subsc" component={Subscriber} />
              <PrivateRoute path="/Pay" component={Pay} />
              <PrivateRoute path="/Port3" component={Port3} />
              <PrivateRoute path="/Port2" component={Port2} />
              <PrivateRoute path="/Port1" component={Port1} />
              <PrivateRoute path="/Rental" component={Rental} />
              <PrivateRoute path="/Port_change" component={PortChange} />
              <PrivateRoute path="/Segway_info" component={SegwayInfo} />
              <PrivateRoute path="/Inquiry" component={Inquiry} />
              {/* 13. UIの出力 */}
              <PrivateRoute path="/Port_change" component={PortChange} />
              <PrivateRoute path="/On_rent" component={OnRent} />
              <PrivateRoute path="/Port_Info" component={PortInfo} />
              <PrivateRoute path="/Receipt" component={ReceiptAdmin} />
              <PrivateRoute path="/User_info" component={UserInfo} />
              <PrivateRoute path="/Rent_log" component={RentLog} />
              <PrivateRoute path="/" component={SegwayInfo} />
            </Switch>
          </Layout>
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
